import type { ImageProps } from "@chakra-ui/react";
import { STORYBLOK_ASSET_MANAGER_URL } from "./utils";

export const COLOR_BROWN = "#DEC8B6";
export const LIGHT_SHADOW = "4px 20px 40px rgba(203, 202, 209, 0.2)";
export const SCORE_RANKING_COLORS = { 1: "warning.500", 2: "greyscale.500", 3: COLOR_BROWN };
export const globalRankingBgStyles = {
  bgRepeat: "no-repeat",
  bgSize: "40%",
  bgColor: "#F3F6F9",
  bgImage: {
    base: "unset",
    lg: `${STORYBLOK_ASSET_MANAGER_URL}/f/108829/722x761/1ff3987b6c/decoration-img-triangles-2.svg`,
  },
};

export const contactSectionMediaStyles = {
  objectFit: "contain",
  maxH: { base: "343px", lg: "414px" },
} as ImageProps;
